import {generateFetchOptions} from '../index';

// ------ API ------

// GET /api/v1/applicants/:applicantId/matches
export async function getApplicantMatches(applicantId: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/applicants/${applicantId}/matches`,
    generateFetchOptions({
      method: 'GET',
      isProtected: true,
    })
  );
}

export async function getApplicantMatchById(applicantId: string, matchId: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/applicants/${applicantId}/matches/${matchId}`,
    generateFetchOptions({
      method: 'GET',
      isProtected: true,
    })
  );
}
